import React, { Component } from 'react'
import styled from 'styled-components'
import OutsideClickHandler from 'react-outside-click-handler'

class DropdownGhostV2 extends Component {
  constructor(props) {
    super(props)
    // Initial state: dropdown is closed
    this.state = {
      isOpen: false,
    }
  }

  // Toggle the dropdown open/close state
  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }))
  }

  render() {
    const { titleArea, children, className, style } = this.props
    const { isOpen } = this.state

    return (
      <OutsideClickHandler
        useCapture
        onOutsideClick={() => this.setState({ isOpen: false })}>
        <Wrapper className={className} style={style}>
          <ClickableArea
            onClick={this.toggleDropdown}
            onKeyDown={this.toggleDropdown}
            role='combobox'
            aria-haspopup={true}
            tabIndex={0}
            aria-labelledby='dropdown-label'
            aria-expanded={isOpen}
            aria-controls='dropdown-content-id'>
            {titleArea}
          </ClickableArea>

          {isOpen && (
            <Content
              id='dropdown-content-id'
              role='listbox'
              aria-labelledby='dropdown-label'>
              {children}
            </Content>
          )}
        </Wrapper>
      </OutsideClickHandler>
    )
  }
}

export default DropdownGhostV2

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  position: relative;
`

const ClickableArea = styled.div`
  display: flex;
  height: 32px;
  padding: 12px 6px;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  cursor: pointer;
`

const Content = styled.div`
  width: 100%;
  position: absolute;
  top: 40px;
  left: -100px;
  z-index: 10;
`



// WEBPACK FOOTER //
// ./src/components/DropdownGhostV2/index.js